import {
  ComcastErrorType,
  triggerSentryError,
} from '../../../../shared/helpers'
import { UserState } from '../../reducers/types/reducerTypes'

export const decodeHTML = (input: string): string => {
  const txt = document.createElement('textarea')

  txt.innerHTML = input.replace(/\/n/g, ' ')
  return txt.value
}

export const handleContentError = (
  source?: string,
  error?: any,
  url?: string
) => {
  const errorDescription = `Error ${
    error?.status ?? '(unknown)'
  } on Settings screen requesting content from ${url ?? '(no URL provided)'}`

  triggerSentryError(source ?? 'unknown-source', 'SettingsScreen.tsx', {
    errorMessage: error?.message ?? 'Undefined error message (default)',
    errorDescription,
    errorLocation: `SettingsScreen - ${source ?? 'unknown-source'}`,
    errorType: ComcastErrorType.network,
  })
}

export const getPassportUrl = (
  canDonate: boolean,
  user: UserState,
  unactivatedPassport: boolean,
  callSign: string
) => {
  if (canDonate) {
    if (!user.validPassportForCurrentStation && !user.validPassport) {
      return '/in-app-donations'
    }
    if (unactivatedPassport) {
      return `/passport-activation?stationTitle=${callSign}`
    }
  }
  return `/passport-upsell/${callSign}`
}
